import React from "react";

import { Wrapper, Container, TextWrap, Title, Text, Image } from "./style";

import { useSelector } from "react-redux";

const selector = state => ({
  component: state.component
});

export default function NascemosParaFacilitar() {
  const { component } = useSelector(selector);
  const {
    doubleSectionTitleTop,
    doubleSectionDescriptionTop,
    doubleSectionBgTopColor,
    doubleSectionImageTop,
    doubleSectionTextColor
  } = component;
  return (
    <Wrapper style={{ backgroundColor: doubleSectionBgTopColor }}>
      <Container>
        <Image src={`https://` + doubleSectionImageTop} />
        <TextWrap>
          <Title color={doubleSectionTextColor}>{doubleSectionTitleTop}</Title>
          <Text color={doubleSectionTextColor}>{doubleSectionDescriptionTop}</Text>
        </TextWrap>
      </Container>
    </Wrapper>
  );
}
